// utils/icons.ts
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar as emptyStar } from '@fortawesome/free-regular-svg-icons';
import {
  faFacebook, faTwitter, faPinterest, faYoutube,
  faLinkedin, faInstagram, faTiktok, faFlipboard,
  faWhatsapp, faTelegram, faXTwitter
} from '@fortawesome/free-brands-svg-icons';

import {
  faAt, faArrowRight, faAngleRight, faAngleLeft,
  faUser, faBriefcase, faWallet, faGreaterThan,
  faHeart, faPaperPlane, faCalendarDays, faArrowUp,
  faThumbsUp, faThumbsDown, faSearch, faUserGear,
  faStar, faDice, faL, faStore, faStar as filledStar,
  faChevronDown, faMapPin, faEnvelopeOpen, faPhone, faEarth,
  faCheck, faClock, faFire, faTimes, faCopy, faBolt, faEye, faChevronLeft, faChevronRight,
  faCompass, faTag, faLayerGroup, faTags, faArrowRightLong, faBagShopping, faXmark,
  faChevronUp, faTruckFast, faRotateLeft, faMinus, faPlus, faChartLine, faShoppingBag, faCalendarCheck, faCircleCheck,
  faShieldHalved, faLock, faHeadset, faPercent, faHome, faCheckCircle, faShieldAlt, faWandMagicSparkles, faCopyright

} from '@fortawesome/free-solid-svg-icons';

export {
  FontAwesomeIcon,
  faFacebook, faTwitter, faPinterest, faYoutube,
  faLinkedin, faInstagram, faTiktok, faFlipboard,
  faWhatsapp, faTelegram,
  faAt, faArrowRight, faAngleRight, faAngleLeft,
  faUser, faBriefcase, faWallet, faGreaterThan,
  faHeart, faPaperPlane, faCalendarDays, faArrowUp,
  faThumbsUp, faThumbsDown, faSearch, faUserGear,
  faStar, faDice, faL, faStore, filledStar, emptyStar,
  faChevronDown, faMapPin, faEnvelopeOpen, faPhone, faEarth,
  faXTwitter, faCheck, faClock, faFire, faTimes, faCopy, faBolt, faEye,
  faChevronLeft, faChevronRight, faCompass, faTag, faLayerGroup, faTags
  , faChevronUp, faArrowRightLong, faBagShopping, faXmark, faTruckFast, faRotateLeft
  , faMinus, faPlus, faChartLine, faShoppingBag, faCalendarCheck, faCircleCheck
  , faShieldHalved, faLock, faHeadset, faPercent, faHome, faShieldAlt, faCheckCircle, faWandMagicSparkles, faCopyright
};
